import React from 'react';
import { CheckCircleIcon, TruckIcon } from 'lucide-react';
export function WhyChooseUs() {
  const reasons = ['Fast response and rapid delivery', 'Experienced and vetted professional drivers', 'Nationwide logistics coverage', 'Multi-service logistics solutions', 'Reliable courier and delivery specialists', 'Trusted by businesses across the UK'];
  return <section className="py-20 bg-slate-900 text-white overflow-hidden relative" data-id="element-199">
      {/* Decorative Background */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-primary/10 -skew-x-12 transform origin-top-right z-0 hidden lg:block" data-id="element-200" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-201">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-202">
          <div className="lg:w-1/2" data-id="element-203">
            <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-204">
              Why Choose Global Universal Logistics
            </h2>

            <ul className="space-y-6" data-id="element-205">
              {reasons.map((reason, index) => <li key={index} className="flex items-start" data-id="element-206">
                  <CheckCircleIcon className="h-6 w-6 text-primary shrink-0 mr-4 mt-0.5" data-id="element-207" />
                  <span className="text-lg text-slate-200" data-id="element-208">{reason}</span>
                </li>)}
            </ul>
          </div>

          <div className="lg:w-1/2 w-full" data-id="element-209">
            <div className="relative rounded-2xl overflow-hidden bg-slate-800 aspect-video flex items-center justify-center border border-slate-700 shadow-2xl" data-id="element-210">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-transparent" data-id="element-211" />
              <TruckIcon className="h-32 w-32 text-slate-600 opacity-50" data-id="element-212" />
              <div className="absolute bottom-6 left-6 right-6 bg-slate-900/80 backdrop-blur p-4 rounded-xl border border-slate-700" data-id="element-213">
                <p className="text-center font-medium text-slate-300" data-id="element-214">
                  Delivering excellence across the United Kingdom
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}